module.exports = __webpack_public_path__ + "img/main1.5dc4a1b7.png";